import React from "react";
import { useState } from "react";
import styled from "styled-components";
import GoodDesc from "../GoodDesc";
import Arrow from "../../../assets/SMSVG/SellerSvg/arrow";
import { baseText } from "../../../Lang/fa/BaseText";

const ListStyle = styled.div`
    text-align: right;
    &.category-desc{
        position: relative;
        border-radius: var(--border-radius-2);
        box-shadow: var(--shadow-6);
        height: 10.5rem;
        margin: 2rem var(--padding);
        padding: 2rem;
        background: var(--body-2);
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        h1{
            line-height: 1.5rem;
            text-align: right;
            margin-bottom: 1rem;
            font-size: 1.3rem;
            width: max-content;
        }
        h2{
            margin-bottom: 1rem;
            width: max-content;
            text-align: right;
            font-size: 1.1rem;
        }
        p{
            line-height: 2rem;
            text-align: justify;
            font-size: 1rem;
        }
        .more{
            position: absolute;
            bottom: 0;
            right: 0;
            display: flex;
            cursor: pointer;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            font-size: var(--fs-good-page-text);
            width: 100%;
            flex-wrap: nowrap;
            color: var(--text-2);
            height: 5.5rem;
            background: linear-gradient(to top , var(--body-2) 70%,transparent);
            .rotate{
                transform: rotate(90deg);
                width: 1rem;
                margin-right: 0.5rem;
            }
            .rotateUp{
                transform: rotate(-90deg);
            }
        }
        &.open-category-desc{
            height: max-content;
            padding-bottom: 5rem;
        }
    }
    @media screen and (max-width : 850px) {
        width: 100%;
        &.category-desc{
            margin: 1rem;
            width: calc(100% - 4rem);
            min-height: 3rem;
            padding: 1rem;
            h1 , .more{
                font-size: 0.8rem;
                margin: 0;
                line-height: 1rem;
            }
            h2{
                font-size: 0.7rem;
            }
            p{
                font-size: 0.7rem;
            }  
            .more{
              
                height: 3.5rem;
                .rotate{
                    width: 0.8rem;
                }
            }
        } 
    }
`

const CatDescription = (props) =>{
    const [openDesc ,setOpenDesc] = useState(false)
    let data=''
    // if(props.name === 'tagpage'){
    //     data = props.groupData.G_TAG_DESC
    // } else 
    if (props.name === 'subcategorypage'){
        data = props.groupData.G_SUBGR_DESC
    }else if (props.name === 'categorypage'){
        data = props.groupData.G_GR_DESC
    }
    if(data){
        return(
            <ListStyle className={'category-desc ' +(openDesc ? 'open-category-desc' : '')}>
                <GoodDesc textFields={JSON.parse(data)}/>
                <div className='more' onClick={()=>setOpenDesc(!openDesc)}>
                    <span>{openDesc ? baseText.closeDesc: baseText.openDesc}</span>
                    <Arrow style={'rotate ' + (openDesc ? 'rotateUp':'') } />
                </div>
            </ListStyle>
        )
    }else{
        return ''
    }

}
export default CatDescription;